module.exports = __webpack_public_path__ + "img/img_15.fc93f4dc.png";